window.abstractArticle = {
    urlWrapper: null,
    urlField: null,
    urlBtn: null,
    urlTooltip: null,
    newsletterCloseBtn: null,
    newsletterCookieName: 'hideNewsletterOverlay',

    /**
     * Initialise the Abstract Article Functions for Article Backend Url
     *
     * @param {HTMLElement} wrapper
     * @return void
     */
    initArticleBackendUrl: function (wrapper) {
        this.urlWrapper = wrapper;
        this.urlField = this.urlWrapper.querySelector('input');
        this.urlBtn = this.urlWrapper.querySelector('.article__url--btn');
        this.urlTooltip = this.urlWrapper.querySelector('.article__url--tooltip');

        this.showHideOrCopyArticleUrl();
    },

    /**
     * Initialise the Abstract Article newsletter overlay close function
     *
     * @param {HTMLElement} wrapper
     * @return void
     */
    initNewsletterOverlay: function (wrapper) {
        this.newsletterCloseBtn = wrapper.querySelector('.icon-close');

        if (!this.getNewsletterOverlayCookieValue()) {
            // show the newsletter if there is no cookie
            wrapper.style.display = 'block';

            this.newsletterCloseBtn.addEventListener('click', () => {
                const date = new Date();
                // The day value of 400 is choosen because of the Browser Standard who says 400 days or less.
                date.setTime(date.getTime() + 400 * 24 * 60 * 60 * 1000);

                // set the cookie
                document.cookie = `${this.newsletterCookieName}=1;expires=${date.toUTCString()};path=/;SameSite=Strict;`;

                // hide the newsletter overlay
                wrapper.style.display = 'none';
            });
        }
    },

    /**
     * Return the value of hideNewsletterOverlay cookie
     *
     * @returns string
     */
    getNewsletterOverlayCookieValue: function () {
        let name = this.newsletterCookieName + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    },

    /**
     * Show/Hide the Url Bar and Copy the Url of the Article on Click
     * @return void
     */
    showHideOrCopyArticleUrl: function () {
        /** On Mouse Enter of the via Url Button show the Url Bar */
        this.urlBtn.addEventListener('mouseenter', () => {
           this.urlWrapper.classList.add('article__url--active');
        });

        /** On Mouse Leave of the url Link hide the Url Bar */
        this.urlWrapper.addEventListener('mouseleave', () => {
           this.urlWrapper.classList.remove('article__url--active');
        });

        /** Click Listener to Copy the Article Url */
        this.urlWrapper.addEventListener('click', () => {
            this.urlField.focus();
            this.urlField.select();
            let copyState = document.execCommand("copy");

            if (copyState) {
                this.urlTooltip.classList.add('article__url--tooltip-active');

                setTimeout(() => {
                    this.urlTooltip.classList.remove('article__url--tooltip-active');
                }, 1500);
            }
        });
    },
}
